









import Vue from 'vue'
export default Vue.extend({
  name: 'SettingListItem',
  props: {
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    isConnected: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    iconClass(): string {
      return `ic-${this.icon}`
    }
  },
  methods: {
    handleClick() {
      this.$emit('handleClick')
    }
  }
})
